import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import useAnnotationFilters from 'hooks/useAnnotationFilters'
import AuthoredByFilter from 'pages/comments/AuthoredByFilter'
import VisibilityFilter from 'pages/comments/VisibilityFilter'
import ArchiveFilter from 'pages/comments/ArchiveFilter'
import ContentPreviewsFilter from 'pages/comments/ContentPreviewsFilter'

const Filters = ({
  selected: category,
  order,
  users,
  privacy,
  allUsers = [],
  userUrn,
  archived,
  preview,
  aol
}) => {
  const {
    authoredByExpanded, setAuthoredByExpanded,
    visibilityExpanded, setVisibilityExpanded,
    archiveExpanded, setArchiveExpanded,
    previewExpanded, setPreviewExpanded
  } = useAnnotationFilters()

  return (
    <Paper className='bg-ice-blue pb4 ph4 mb6' classes={{ root: 'br0' }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <AuthoredByFilter
            {...{ users, category, order, privacy, archived, allUsers, userUrn, aol }}
            expanded={authoredByExpanded}
            setExpanded={setAuthoredByExpanded}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <VisibilityFilter
            {...{ category, order, users, privacy, archived, preview, aol }}
            expanded={visibilityExpanded}
            setExpanded={setVisibilityExpanded}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ArchiveFilter
            {...{ category, order, users, privacy, archived, preview, aol }}
            expanded={archiveExpanded}
            setExpanded={setArchiveExpanded}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ContentPreviewsFilter
            {...{ category, order, users, privacy, archived, preview, aol }}
            expanded={previewExpanded}
            setExpanded={setPreviewExpanded}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default Filters
